import graphql__2f49bc1d6b3d0b274599 from "./__generated__/ContributionsDatavizThemeViewSidebar_theme.graphql.js";import { useCallback } from "react";
import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";
import classNames from "classnames";

import { useFormatMessage } from "../../../Intl/Context";
import { useNavigateTo } from "../../../Routes/RoutesContext";
import { Desktop } from "../../../Utils/ResponsiveQueries";
import Button from "../../../Buttons/Button";
import Icon from "../../../Utils/Icon";
import ContributionsDatavizFilters from "./ContributionsDatavizFilters";
import ContributionsDatavizSearchFiltersThemes from "./ContributionsDatavizSearchFiltersThemes";
import ContributionsDatavizThemesCarousel from "./ContributionsDatavizThemesCarousel";
import ContributionsDatavizThemeMeasures from "./ContributionsDatavizThemeMeasures";
import ContributionsDatavizSorting from "./ContributionsDatavizSorting";

const ContributionsDatavizThemeViewSidebar = props => {
  const theme = useFragment(ContributionsDatavizThemeViewSidebar_theme, props.theme);
  const { participativeModule, primaryColor, primaryContrastColor } = theme;
  const participativeModuleSlug = participativeModule.slug;

  const parentTheme = theme.parent;

  const {
    className,
    graphViewActive,
    listViewActive,
    filtersRefetchFragment,
    filtersRefetchFragmentParent,
    pagesCount
  } = props;

  const iconClassNames = classNames(["align-middle", theme.iconClass]);

  const t = useFormatMessage();
  const backToThemesLabel = t(intlMessages.backToThemes);
  const themesFilterTitle = t(intlMessages.themesFilterTitle);

  const backPathName = graphViewActive ? "datavizGraph" : "datavizList";

  const navigateTo = useNavigateTo();
  const handleBackButtonClicked = useCallback(
    () => navigateTo(backPathName, { participativeModuleSlug }),
    [backPathName, navigateTo, participativeModuleSlug]
  );

  // We force a boolean value for the second part of the condition to avoid a 0
  // `pagesCount` value to render a `0` in JSX.
  const displaySorting = listViewActive || !!(pagesCount && pagesCount > 1);

  return (
    <div className={className}>
      <Button
        className="participative-datavisualization-theme-view-header btn btn-block btn-primary text-uppercase margin-bottom-xs"
        data-dataviz-back-to-themes-button
        onClick={handleBackButtonClicked}
        label={backToThemesLabel}
        iconClassName="icon-arrow-left"
        innerClassName="padding-xs d-flex"
      />

      <div className="theme box margin-bottom-xs padding-sm">
        {parentTheme && (
          <div
            style={{ backgroundColor: primaryColor, color: primaryContrastColor }}
            className="name d-inline-block rounded-pill margin-bottom-xs text-uppercase padding-x-sm padding-y-xs"
          >
            {parentTheme.name}
          </div>
        )}

        <div className="d-flex align-items-center margin-bottom-xs">
          <span
            style={{ backgroundColor: primaryColor, color: primaryContrastColor }}
            className="margin-right-xs flex-shrink-0 icon d-inline-block big text-center text-greater"
          >
            <Icon className={iconClassNames} />
          </span>
          <h2 className="text-bolder">{theme.name}</h2>
        </div>

        <Desktop>
          <ContributionsDatavizThemeMeasures theme={theme} className="margin-bottom-xs" />
        </Desktop>

        <ContributionsDatavizThemesCarousel
          currentTheme={theme}
          participativeModule={participativeModule}
          graphViewActive={graphViewActive}
          listViewActive={listViewActive}
        />
      </div>

      {displaySorting && <ContributionsDatavizSorting />}

      <ContributionsDatavizFilters
        participativeModule={participativeModule}
        refetchFragment={filtersRefetchFragment}
        refetchFragmentParent={filtersRefetchFragmentParent}
      >
        {theme.children.length > 0 && (
          <div className="padding-bottom-xs margin-bottom-xs border-bottom">
            <h3 className="text-bolder d-block margin-bottom-xs">{themesFilterTitle}</h3>
            <ContributionsDatavizSearchFiltersThemes themes={theme.children} />
          </div>
        )}
      </ContributionsDatavizFilters>
    </div>
  );
};

const ContributionsDatavizThemeViewSidebar_theme = graphql__2f49bc1d6b3d0b274599;

export default ContributionsDatavizThemeViewSidebar;

const intlMessages = defineMessages({
  backToThemes: {
    id: "contributions.dataviz.sidebar.backToThemes",
    defaultMessage: "retour aux thèmes"
  },
  themesFilterTitle: {
    id: "contributions.dataviz.sidebar.themesFilterTitle",
    defaultMessage: "Filtrer par sous-thématique"
  }
});
